import { TFunction } from 'i18next';
import { config } from '../config';
import { resources } from '../resources/resources';

export const rewriteImageUrl = (
  url?: string,
  width?: number,
  height?: number,
) => {
  if (!url?.length) {
    return '';
  }

  return !!width && !!height
    ? `${config.imagesUrl}/${url}?width=${width}&height=${height}`
    : `${config.imagesUrl}/${url}`;
};

export const getOptionalLabel = (label: string, translate: TFunction) => {
  return `${label} ${translate(resources.optionalLabel)}`;
};
